import {Component, signal, Signal, WritableSignal} from '@angular/core';
import {RouterModule} from '@angular/router';
import {combineLatest} from 'rxjs';
import {filter, map, switchMap, tap} from 'rxjs/operators';
import {Folder, Organization, Query} from '../../../types-repository';
import {Apollo} from 'apollo-angular';
import {GET_ROOTS} from '../../../queries-repository';
import {LogoAreaComponent} from '../../logo-area/logo-area.component';
import {HeadlineSectionComponent} from '../../headline-section/headline-section.component';
import { AsyncPipe } from '@angular/common';
import {FileFolderLinkPipe} from '../../file-folder-link.pipe';
import {ContextService} from '../../../services/context.service';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {OrgResolverPipe} from '../../../pipes/org-resolver-pipe';
import {CldatePipe} from '../../../pipes/cldate.pipe';

@Component({
  selector: 'app-home-component',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss'],
  imports: [
    LogoAreaComponent,
    HeadlineSectionComponent,
    RouterModule,
    FileFolderLinkPipe,
    OrgResolverPipe,
    CldatePipe
]
})
export class HomeComponent {

  loading: WritableSignal<boolean> = signal(true);
  roots: Signal<Folder[]>;
  organization: Signal<Organization>;

  /** Bumped by refresh() to re-run the query without the organization having changed. */
  private reload: WritableSignal<number> = signal(0);

  constructor(private apollo: Apollo,
              private organizationService: ContextService) {
    this.organization = this.organizationService.organization
    this.roots = toSignal(
      combineLatest([toObservable(this.organization), toObservable(this.reload)]).pipe(
        filter(([_org]) => !!_org),
        tap(() => this.loading.set(true)),
        // network-only, not the default cache-first: the roots are cached per organization, so
        // switching away and back served a stale list -- and the list genuinely changes underneath
        // us, since a supplier's roots are the delivery directories that exist right now.
        switchMap(([_org]) => this.apollo.query<Query>({query: GET_ROOTS(_org.id), fetchPolicy: 'network-only'})),
        map(res => [...res.data.roots].sort((a, b) => a.name.localeCompare(b.name))),
        tap(() => this.loading.set(false))
      ),
      {initialValue: []}
    )
  }

  refresh() {
    this.reload.update(n => n + 1);
  }
}
